module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mres8-c8e729c056d4372706463dabc555fd51.jpg";